import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import api from "../Api";
import { useFlash } from "../context/flashcontext";

export function useProjects(userId) {
    const { t } = useTranslation();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [totalProfit, setTotalProfit] = useState(0);
    const { showFlash } = useFlash();
    const fetchProjects = useCallback(async () => {
        setLoading(true);
        try {
            let response;
            if (userId) {
                response = await api.get(`/users/${userId}/projects`);
            } else {
                response = await api.get("/projects");
            }
            setProjects(response.data);
            setError(null);
            setLoading(false);
            // Calculate total profit from backend data
            const total = response.data.reduce((acc, p) => acc + (p.profit || 0), 0);
            setTotalProfit(total);
        } catch (err) {
            setError("Failed to load projects. Please try again.");
            setLoading(false);
        }
    }, [userId]);

    const deleteProject = async (id) => {
        try {
            await api.delete(`/projects/${id}`);
            showFlash(t('success.projectDeleted'), "success");
            await fetchProjects();
        } catch (err) {
            showFlash(t('errors.projectDeleteFailed'), "error");
        }
    };

    useEffect(() => {
        fetchProjects();
    }, [fetchProjects]);

    return {
        projects,
        loading,
        error,
        totalProfit,
        fetchProjects,
        deleteProject,
    };
}
